import React, { useEffect, useState } from 'react';
import API from '../utils/api';
import './AdminList.css';

const AdminList = () => {
  const [users, setUsers] = useState([]);
  const [emailInput, setEmailInput] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    API.get('/users')
      .then(res => setUsers(res.data))
      .catch(err => console.log(err));
  }, []);

  const refresh = async () => {
    const res = await API.get('/users');
    setUsers(res.data);
  }

  const deleteAdminByEmail = async () => {
    if (!emailInput.trim()) { setMessage('Please enter email'); return; }
    try {
      await API.delete(`/users/admin`, { data: { email: emailInput } });
      setMessage('✅ Admin deleted');
      setEmailInput('');
      await refresh();
    } catch (e) {
      setMessage(`❌ ${e.response?.data?.message || e.message}`);
    }
  }

  const changePasswordByEmail = async () => {
    if (!emailInput.trim() || !newPassword.trim()) { setMessage('Enter email and new password'); return; }
    try {
      await API.put(`/users/admin/password`, { email: emailInput, password: newPassword });
      setMessage('✅ Password updated');
      setEmailInput('');
      setNewPassword('');
    } catch (e) {
      setMessage(`❌ ${e.response?.data?.message || e.message}`);
    }
  }

  return (
    <div className="user-list-container">
      <h2>All Users</h2>
      <div className="admin-actions">
        <input
          type="email"
          placeholder="Admin email"
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
        />
        <input
          type="password"
          placeholder="New password (optional)"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <button onClick={deleteAdminByEmail} className="danger">Delete Admin</button>
        <button onClick={changePasswordByEmail}>Change Password</button>
      </div>
      <table className="user-table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Role</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u._id}>
              <td>{u.email}</td>
              <td>{u.role}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default AdminList;

